import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { LoadingPage } from "../LoadingPage";
import { withAuthorization } from "../Session";
import { EvaluationItem } from "./EvaluationItem";
import { EvaluationResult } from "./EvaluationResult";
import LinearProgressWithLabel from "../LinearProgressWithLabel";

import * as ROUTES from "../../constants/routes";
import { Backdrop, Breadcrumbs, CircularProgress, Container, Grid, Link, Snackbar, Typography } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { useTranslation } from "react-i18next";
import { Home } from "@material-ui/icons";

export const EvaluationPage = (props) => {
  /**
   * Hay que ver como sa procesa cuando un test se deja a la mitad,
   * ahora no cuenta como intento, por lo que se podria hacer trampas
   * se puede hacer todo el test menos la ultima y volver a empezar
   *
   * hay que decidir que se tiene que hacer cuando se llega a los 3 intentos
   *
   * Con que ratio de aciertos aprueba el usuario
   *
   * Estaba hecho que el usuario podia saltar una pregunta
   */
  const { firebase } = props;
  const { t } = useTranslation();
  const [evaluationState, setevaluationState] = useState("loading"); //op: loading, loaded, finished
  const [currentTest, setCurrentTest] = useState(0);
  const [max, setMax] = useState(0);
  const [attemp, setAttemp] = useState(0);
  const [testData, setTestData] = useState([]);
  const [resultData, setResultData] = useState("");
  const [feedbackDialogOpen, setfeedbackDialogOpen] = useState(false);
  const [isCorrectAnswer, setisCorrectAnswer] = useState(false);
  const [savingData, setSavingData] = useState(false);

  let { id } = useParams();

  const courseId = {
    ECS1: "FCSReconocimientoPrecoz",
    ECS2: "FCSRCPPrecoz",
    ECS3: "FCSDesfibrilacionPrecoz",
  };

  /** porcentaje de aciertos necesarios, 100% */
  const hitRatio = 1;
  const history = useHistory();

  useEffect(() => {
    firebase
      .evaluationMetadata(firebase.currentUser().uid, id)
      .once("value")
      .then((metadata) => {
        metadata = metadata.val();
        //En caso de no haber pasado por la formación redirigir al Home
        !metadata.studed && history.push(ROUTES.HOME);

        !!!metadata.nAttemps && setAttemp(0);
        if (metadata.isOnProgress) {
          setCurrentTest(metadata.currentQuestion);
          setAttemp(metadata.nAttemps);
          firebase.checkRescuer();
        } else {
          if (metadata.isReviewed === false) {
            firebase
              .evaluationMetadata(firebase.currentUser().uid, id)
              .update({
                currentQuestion: "",
                //isReviewed: true,
              })
              .then(() => history.push(ROUTES.EVALUATIONPASSED.replace(":attemp", metadata.nAttemps).replace(":course", id).replace(":uid", firebase.currentUser().uid)));
          } else {
            setAttemp(metadata.nAttemps + 1);
            firebase
              .evaluationMetadata(firebase.currentUser().uid, id)
              .update({
                nAttemps: metadata.nAttemps + 1,
                isOnProgress: true,
                evalApproved: false,
                currentQuestion: 0,
              })
              .then(() => firebase.checkRescuer());
          }
        }
      });
    /*   ***  CARGA DE DATOS FIREBASE ***
     *  Cargar la lista de preguntas que se van a realizar en este test, equivale a los items de la formación. 
        Este método solo carga los datos de firebase para renderizar los contenidos     */
    firebase
      .evaluationTest(id)
      .once("value")
      .then((snap) => {
        let itemList = [];
        firebase
          .getTestItems()
          .once("value")
          .then((items) => {
            snap.val().map((testId) => {
              itemList.push(items.val()[testId]);
            });
            setTestData(itemList);
            setMax(itemList.length - 1);
            firebase.evaluationMetadata(firebase.currentUser().uid, id).update({ totalQuestions: itemList.length });
            setevaluationState("loaded");
          });
      });
  }, []);

  const nextFase = () => {
    if (currentTest >= max) {
      setSavingData(true);
      firebase
        .evaluationAttemp(firebase.currentUser().uid, id, attemp)
        .once("value")
        .then((snap) => {
          setResultData(snap.val());
          const correct = !!snap.val()?.metadata?.correct ? snap.val()?.metadata?.correct : 0;
          const wrong = !!snap.val()?.metadata?.wrong ? snap.val()?.metadata?.wrong : 0;
          const correctRatio = correct / (correct + wrong);
          firebase
            .evaluationMetadata(firebase.currentUser().uid, id)
            .update({
              currentQuestion: "",
              isOnProgress: false,
              evalApproved: correctRatio == hitRatio,
              isReviewed: false,
            })
            .then(() => {
              firebase.checkRescuer();
              history.push(ROUTES.EVALUATIONPASSED.replace(":attemp", attemp).replace(":course", id).replace(":uid", firebase.currentUser().uid));
            });
        });
    } else {
      setCurrentTest(currentTest + 1);
    }
  };

  const answerFeedback = (error) => {
    setfeedbackDialogOpen(true);
    setisCorrectAnswer(!error);
  };

  switch (evaluationState) {
    case "loading":
      return <LoadingPage />;

    case "loaded":
      return (
        <Grid container justify="center" style={{ paddingTop: 16 }}>
          <Grid item xs={12} lg={9}>
            <Container>
              <Breadcrumbs>
                <Link
                  color="inherit"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    history.push(ROUTES.HOME);
                    window.scrollTo({ y: 0, behavior: "smooth" });
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <Home style={{ paddingBottom: 8, paddingRight: 4 }} />
                    <Typography style={{ paddingTop: 4, textDecoration: "underline" }}>{t("curso_Online")}</Typography>
                  </div>
                </Link>

                <Link
                  color="inherit"
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => {
                    history.push(ROUTES.MODULE.replace(":id", courseId[id]));
                    window.scrollTo({ y: 0, behavior: "smooth" });
                  }}
                >
                  {t(courseId[id]?.replace("FCS", ""))}
                </Link>
                <Typography color="textPrimary">{t("evaluacion")}</Typography>
              </Breadcrumbs>
            </Container>
          </Grid>
          <Grid item xs={12} md={6} container spacing={4} style={{ marginTop: 4 }}>
            <LinearProgressWithLabel value={(currentTest / (max + 1)) * 100} color="primary" />
            <EvaluationItem
              nextItem={nextFase}
              data={testData[currentTest]}
              current={currentTest}
              max={max}
              nAttemps={attemp}
              firebase={firebase}
              evaluationID={id}
              answerFeedback={answerFeedback}
            />
          </Grid>
          <Snackbar
            style={{ marginTop: "10vh", marginRight: 32 }}
            open={feedbackDialogOpen}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            autoHideDuration={4000}
            onClose={() => setfeedbackDialogOpen(false)}
          >
            <MuiAlert elevation={6} variant="filled" severity={!isCorrectAnswer ? "error" : "success"}>
              {isCorrectAnswer ? t("correctAnswer") : t("wrongAnswer")}
            </MuiAlert>
          </Snackbar>
          <Backdrop open={savingData} style={{ zIndex: 10 }}>
            <CircularProgress style={{ color: "white" }} />
          </Backdrop>
        </Grid>
      );
  }
};

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(EvaluationPage);
